import React from "react";
import { GoogleLogin } from "react-google-login";
import { makeStyles } from "@material-ui/styles";
const useStyles = makeStyles({
  butt: {
    paddingLeft: "14px !important"
  }
});

export default function GoogleLoginForm(props) {
  const { multiLang, lang, dir } = props;
  const classes = useStyles();
  async function responseGoogle(response) {
    // console.log(response);
    props.login(response.Zi.access_token);
  }

  return (
    <div>
      <GoogleLogin
        clientId="211720579099-u6rd3p8d22bi5ek7a425flalhbn3p055.apps.googleusercontent.com"
        buttonText={multiLang["027"][lang]}
        onSuccess={responseGoogle}
        onFailure={responseGoogle}
        //   cookiePolicy={"single_host_origin"}
        className={dir === "rtl" ? classes.butt : ""}
      />
    </div>
  );
}
